var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import omit from "lodash/omit";
import { client } from "../client";
export var getTracksByIds = function (tracksIds) {
    return client
        .get("/api/v1/tracks/" + tracksIds.join(","))
        .then(function (response) {
        var tracks = [];
        var _loop_1 = function (id) {
            var track = response.data.tracks.find(function (track) { return track.id === id; });
            if (!track)
                return "continue";
            tracks.push(__assign(__assign({}, omit(track, ["is_private", "user_id", "md5", "size"])), { isPrivate: track.is_private, userId: track.user_id }));
        };
        for (var _i = 0, tracksIds_1 = tracksIds; _i < tracksIds_1.length; _i++) {
            var id = tracksIds_1[_i];
            _loop_1(id);
        }
        return tracks;
    });
};
export var getRawTracksByIds = function (tracksIds) {
    return client
        .get("/api/v2/tracks/" + tracksIds.join(","))
        .then(function (response) {
        var tracks = [];
        var track = response.data.data;
        tracks.push(track);
        return tracks;
    });
};
